(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-item"] && !Shopify.designMode) return;
  try {
    (() => {
    const OPEN_CLASS = 'is-open';
    const BUTTON_SELECTOR = '.accordion-item__button';
    const PANEL_SELECTOR = '.accordion-item__panel';
    const TOGGLE_EVENT = 'accordion-item:toggle';
    const CHANGE_EVENT = 'accordion-group:change';

    if (!customElements.get('accordion-item')) {
      class AccordionItem extends HTMLElement {
        handleClick = (event) => {
          const button = event.target.closest(BUTTON_SELECTOR);

          if (!button || !this.contains(button)) {
            return;
          }

          this.dispatchEvent(new CustomEvent(TOGGLE_EVENT, { bubbles: true }));
        };

        get isOpen() {
          return this.classList.contains(OPEN_CLASS);
        }

        connectedCallback() {
          this.abortController = new AbortController();

          this.addEventListener('click', this.handleClick, {
            signal: this.abortController.signal,
          });
        }

        disconnectedCallback() {
          this.abortController.abort();
        }

        open() {
          const button = this.querySelector(BUTTON_SELECTOR);
          const panel = this.querySelector(PANEL_SELECTOR);

          button.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
          this.classList.add(OPEN_CLASS);
        }

        close() {
          const button = this.querySelector(BUTTON_SELECTOR);
          const panel = this.querySelector(PANEL_SELECTOR);

          button.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
          this.classList.remove(OPEN_CLASS);
        }
      }

      customElements.define('accordion-item', AccordionItem);
    }

    if (!customElements.get('accordion-group')) {
      class AccordionGroup extends HTMLElement {
        handleToggle = (event) => {
          const item = event.target;

          if (item.parentElement !== this) {
            return;
          }

          const wasOpen = item.isOpen;

          this.closeItems();

          if (wasOpen) {
            this.dispatchChange(null);
            return;
          }

          item.open();
          this.dispatchChange(item);
        };

        connectedCallback() {
          this.abortController = new AbortController();

          this.addEventListener(TOGGLE_EVENT, this.handleToggle, {
            signal: this.abortController.signal,
          });
        }

        disconnectedCallback() {
          this.abortController.abort();
        }

        closeItems() {
          const items = this.querySelectorAll(':scope > accordion-item');

          items.forEach((item) => {
            item.close();
          });
        }

        dispatchChange(item) {
          const detail = { item };

          this.dispatchEvent(new CustomEvent(CHANGE_EVENT, { bubbles: true, detail }));
        }
      }

      customElements.define('accordion-group', AccordionGroup);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bundle-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-products')) {
    const STOREFRONT_API_VERSION = '2026-10';
    const BUNDLE_ITEM_VIEW = 'bundle-item';
    const LIST_SELECTOR = '.bundle-products__list';
    const BUNDLE_PRODUCTS_QUERY = `
      query BundleProducts($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            handle
          }
        }
      }
    `;

    class BundleProducts extends HTMLElement {
      connectedCallback() {
        if (this.hasLoadedProducts) {
          return;
        }

        this.hasLoadedProducts = true;

        const productIds = (this.dataset.productIds || '')
          .split(',')
          .filter((productId) => productId !== '');

        if (productIds.length === 0) {
          return;
        }

        this.loadProducts(productIds);
      }

      async loadProducts(productIds) {
        const endpoint = `https://${this.dataset.storeDomain}/api/${STOREFRONT_API_VERSION}/graphql.json`;

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query: BUNDLE_PRODUCTS_QUERY,
            variables: {
              ids: productIds,
            },
          }),
        });

        if (!response.ok) {
          return;
        }

        const payload = await response.json();
        const products = payload.data && payload.data.nodes ? payload.data.nodes : [];

        const handles = products
          .filter((product) => product && product.handle)
          .map((product) => product.handle);

        const itemMarkupList = await Promise.all(handles.map((handle) => this.fetchBundleItem(handle)));

        this.renderItems(itemMarkupList.filter((markup) => markup !== ''));
      }

      async fetchBundleItem(handle) {
        const bundleItemUrl = `${this.productUrl(handle)}?view=${BUNDLE_ITEM_VIEW}`;

        try {
          const response = await fetch(bundleItemUrl);

          if (!response.ok) {
            return '';
          }

          return (await response.text()).trim();
        } catch {
          return '';
        }
      }

      renderItems(itemMarkupList) {
        const list = this.querySelector(LIST_SELECTOR);

        if (!list) {
          return;
        }

        list.innerHTML = itemMarkupList.join('');
      }

      productUrl(handle) {
        const rootUrl = this.dataset.rootUrl || '/';
        const prefix = rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;

        return `${prefix}/products/${handle}`;
      }
    }

    customElements.define('bundle-products', BundleProducts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    const stickyBars = document.querySelectorAll('[data-product-sticky-bar]');

  const syncStickyBarOffset = (bar) => {
    document.documentElement.style.setProperty('--product-sticky-bar-offset', `${bar.offsetHeight}px`);
  };

  stickyBars.forEach((bar) => {
    const form = bar.closest('product-form');
    const addToCartButton = form ? form.querySelector('[data-add-to-cart]') : null;
    let isAddToCartButtonVisible = true;

    const setBarVisible = (isVisible) => {
      bar.classList.toggle('is-visible', isVisible);

      if (isVisible) {
        bar.removeAttribute('inert');
        syncStickyBarOffset(bar);
        return;
      }

      bar.setAttribute('inert', '');
    };

    const updateBarVisibility = () => {
      setBarVisible(!isAddToCartButtonVisible);
    };

    if (addToCartButton) {
      const visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          isAddToCartButtonVisible = entry.isIntersecting;
          updateBarVisibility();
        });
      });

      visibilityObserver.observe(addToCartButton);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-media')) {
    const DRAG_START_DISTANCE = 4;
    const SCROLL_EDGE_TOLERANCE = 1;
    const SCROLL_END_DELAY = 80;
    const DESKTOP_MIN_WIDTH = 1024;
    const ACTIVE_CLASS = 'is-active';
    const HIDDEN_CLASS = 'is-hidden';
    const DRAGGING_CLASS = 'is-dragging';
    const SCROLLABLE_CLASS = 'is-scrollable';
    const FANCYBOX_MAIN_CLASS = 'product-media-zoom';
    const ZOOM_BUTTON_SELECTOR = '[data-media-zoom]';
    const HORIZONTAL_AXIS = {
      pointer: 'clientX',
      offset: 'offsetLeft',
      scroll: 'scrollLeft',
      scrollSize: 'scrollWidth',
      clientSize: 'clientWidth',
      scrollTo: 'left',
    };
    const VERTICAL_AXIS = {
      pointer: 'clientY',
      offset: 'offsetTop',
      scroll: 'scrollTop',
      scrollSize: 'scrollHeight',
      clientSize: 'clientHeight',
      scrollTo: 'top',
    };

    class ScrollSlider {
      constructor({ element, itemSelector, axis, previousButton, nextButton, onIndexChange, signal }) {
        this.element = element;
        this.itemSelector = itemSelector;
        this.axis = axis;
        this.previousButton = previousButton;
        this.nextButton = nextButton;
        this.onIndexChange = onIndexChange;
        this.dragPointerId = null;
        this.dragStartCoordinate = 0;
        this.dragStartScrollPosition = 0;
        this.hasDragged = false;
        this.suppressItemClick = false;
        this.isAnimating = false;
        this.targetSlideIndex = 0;
        this.scrollEndTimer = null;

        if (!this.element) {
          return;
        }

        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.previousButton?.addEventListener('click', () => this.scrollBySlides(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollBySlides(1), { signal });
        this.element.addEventListener('click', (event) => this.onItemClick(event), { capture: true, signal });
        this.element.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
        this.element.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.element.addEventListener('scroll', () => this.onElementScroll(), { passive: true, signal });

        this.resizeObserver = new ResizeObserver(() => {
          this.alignAfterResize();
        });

        this.resizeObserver.observe(this.element);
        this.updateButtons();
      }

      destroy() {
        window.clearTimeout(this.scrollEndTimer);
        this.resizeObserver?.disconnect();
        this.removeDragListeners();
      }

      alignAfterResize() {
        if (!this.element || this.dragPointerId !== null) {
          return;
        }

        if (!this.isScrollable()) {
          this.updateButtons();
          return;
        }

        const positions = this.getSlideScrollPositions();
        const slideIndex = this.getNearestSlideIndex();
        const scrollPosition = positions[slideIndex] ?? 0;

        this.targetSlideIndex = slideIndex;

        if (Math.abs(this.getScrollPosition() - scrollPosition) > SCROLL_EDGE_TOLERANCE) {
          this.setScrollPosition(scrollPosition);
        }

        this.updateButtons();
        this.onIndexChange?.(slideIndex);
      }

      onItemClick(event) {
        if (!this.suppressItemClick) {
          return;
        }

        this.suppressItemClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      onPointerDown(event) {
        if (event.pointerType === 'touch') {
          this.isAnimating = false;
          return;
        }

        if (event.button !== 0 || !this.isScrollable()) {
          return;
        }

        this.isAnimating = false;
        this.suppressItemClick = false;
        this.dragPointerId = event.pointerId;
        this.dragStartCoordinate = event[this.axis.pointer];
        this.dragStartScrollPosition = this.getScrollPosition();
        this.hasDragged = false;

        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (event.pointerId !== this.dragPointerId) {
          return;
        }

        const dragDistance = event[this.axis.pointer] - this.dragStartCoordinate;

        if (!this.hasDragged && Math.abs(dragDistance) < DRAG_START_DISTANCE) {
          return;
        }

        if (!this.hasDragged) {
          this.hasDragged = true;
          this.element.classList.add(DRAGGING_CLASS);
          this.element.style.scrollSnapType = 'none';
        }

        event.preventDefault();
        this.setScrollPosition(this.dragStartScrollPosition - dragDistance);
      }

      onPointerUp(event) {
        if (event.pointerId !== this.dragPointerId) {
          return;
        }

        const shouldSnap = this.hasDragged;

        this.dragPointerId = null;
        this.hasDragged = false;
        this.removeDragListeners();

        if (!shouldSnap) {
          this.endDrag();
          return;
        }

        this.suppressItemClick = true;
        this.scrollToIndex(this.getNearestSlideIndex());
      }

      removeDragListeners() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
      }

      endDrag() {
        this.element?.classList.remove(DRAGGING_CLASS);

        if (!this.element || this.element.style.scrollSnapType === '') {
          return;
        }

        this.element.style.scrollSnapType = '';
      }

      onElementScroll() {
        this.updateButtons();

        if (!this.isScrollable()) {
          return;
        }

        if (this.dragPointerId !== null || !this.isAnimating) {
          this.syncToNearestSlide();
        }

        if (this.dragPointerId !== null) {
          return;
        }

        window.clearTimeout(this.scrollEndTimer);

        this.scrollEndTimer = window.setTimeout(() => {
          this.endDrag();
          this.isAnimating = false;
          this.syncToNearestSlide();
        }, SCROLL_END_DELAY);
      }

      syncToNearestSlide() {
        const slideIndex = this.getNearestSlideIndex();

        this.targetSlideIndex = slideIndex;
        this.updateButtons();
        this.onIndexChange?.(slideIndex);
      }

      scrollBySlides(offset) {
        this.scrollToIndex(this.targetSlideIndex + offset);
      }

      scrollToIndex(index, behavior = 'smooth') {
        if (!this.isScrollable()) {
          return;
        }

        const positions = this.getSlideScrollPositions();

        if (positions.length === 0) {
          return;
        }

        const clampedIndex = Math.min(Math.max(index, 0), positions.length - 1);
        const scrollPosition = positions[clampedIndex];

        this.targetSlideIndex = clampedIndex;
        this.updateButtons();

        if (Math.abs(this.getScrollPosition() - scrollPosition) <= SCROLL_EDGE_TOLERANCE) {
          this.isAnimating = false;
          this.endDrag();
          this.onIndexChange?.(clampedIndex);
          return;
        }

        this.isAnimating = behavior === 'smooth';

        this.element.scrollTo({
          [this.axis.scrollTo]: scrollPosition,
          behavior,
        });

        if (!this.isAnimating) {
          this.onIndexChange?.(clampedIndex);
        }
      }

      getNearestSlideIndex() {
        const scrollPosition = this.getScrollPosition();

        return this.getSlideScrollPositions().reduce((nearestIndex, position, index, positions) => {
          const nearestDistance = Math.abs(positions[nearestIndex] - scrollPosition);
          const distance = Math.abs(position - scrollPosition);

          return distance < nearestDistance ? index : nearestIndex;
        }, 0);
      }

      getSlideScrollPositions() {
        const items = Array.from(this.element.querySelectorAll(this.itemSelector));
        const maximumScroll = this.getMaximumScroll();
        const positions = [];

        items.forEach((item, index) => {
          const rawPosition = item[this.axis.offset] - items[0][this.axis.offset];
          const scrollPosition = Math.min(Math.max(rawPosition, 0), maximumScroll);
          const previousScrollPosition = positions.at(-1);

          if (index > 0 && previousScrollPosition !== undefined && Math.abs(scrollPosition - previousScrollPosition) <= SCROLL_EDGE_TOLERANCE) {
            return;
          }

          positions.push(scrollPosition);
        });

        return positions;
      }

      getScrollPosition() {
        return this.element[this.axis.scroll];
      }

      setScrollPosition(position) {
        this.element[this.axis.scroll] = position;
      }

      getMaximumScroll() {
        if (!this.element) {
          return 0;
        }

        return Math.max(this.element[this.axis.scrollSize] - this.element[this.axis.clientSize], 0);
      }

      isScrollable() {
        return this.getMaximumScroll() > SCROLL_EDGE_TOLERANCE;
      }

      updateButtons() {
        if (!this.element) {
          return;
        }

        const scrollPosition = this.getScrollPosition();
        const maximumScroll = this.getMaximumScroll();
        const canScroll = maximumScroll > SCROLL_EDGE_TOLERANCE;

        this.element.classList.toggle(SCROLLABLE_CLASS, canScroll);
        this.setButtonHidden(this.previousButton, !canScroll || scrollPosition <= SCROLL_EDGE_TOLERANCE);
        this.setButtonHidden(this.nextButton, !canScroll || scrollPosition >= maximumScroll - SCROLL_EDGE_TOLERANCE);
      }

      setButtonHidden(button, isHidden) {
        if (!button) {
          return;
        }

        button.classList.toggle(HIDDEN_CLASS, isHidden);
        button.disabled = isHidden;
        button.toggleAttribute('aria-hidden', isHidden);
      }
    }

    class ProductMedia extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') {
          return;
        }

        this.dataset.ready = 'true';
        this.abortController = new AbortController();

        const signal = this.abortController.signal;

        this.mediaQuery = window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`);
        this.mainItems = Array.from(this.querySelectorAll('.product__media__main-item'));
        this.thumbnailButtons = Array.from(this.querySelectorAll('.product__media__thumbnail[data-media-index]'));
        this.dots = Array.from(this.querySelectorAll('.product__media__dot'));
        this.activeIndex = Math.max(this.mainItems.findIndex((item) => item.classList.contains(ACTIVE_CLASS)), 0);

        this.thumbnailSlider = new ScrollSlider({
          element: this.querySelector('.product__media__thumbnails-slider'),
          itemSelector: '.product__media__thumbnail',
          axis: VERTICAL_AXIS,
          previousButton: this.querySelector('[data-thumbnails-previous]'),
          nextButton: this.querySelector('[data-thumbnails-next]'),
          signal,
        });

        this.mainSlider = new ScrollSlider({
          element: this.querySelector('.product__media__main'),
          itemSelector: '.product__media__main-item',
          axis: HORIZONTAL_AXIS,
          onIndexChange: (index) => this.setActiveMedia(index),
          signal,
        });

        this.addEventListener('click', (event) => this.onMediaClick(event), { signal });
        this.querySelector('.product__media__video-button')?.addEventListener('click', () => this.openVideo(), { signal });
        this.mediaQuery.addEventListener('change', () => this.onMediaQueryChange(), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.thumbnailSlider?.destroy();
        this.mainSlider?.destroy();
        this.dataset.ready = 'false';
      }

      onMediaQueryChange() {
        if (this.mediaQuery.matches) {
          return;
        }

        this.mainSlider.scrollToIndex(this.activeIndex, 'auto');
      }

      openVideo() {
        const videoLink = this.querySelector('a[data-fancybox^="video"]');

        videoLink?.click();
      }

      openZoom(zoomButton) {
        if (typeof Fancybox === 'undefined') {
          return;
        }

        const zoomButtons = Array.from(this.querySelectorAll(ZOOM_BUTTON_SELECTOR));
        const startIndex = zoomButtons.indexOf(zoomButton);

        if (startIndex < 0) {
          return;
        }

        const slides = zoomButtons.map((button) => this.getZoomSlide(button));

        Fancybox.show(slides, {
          startIndex,
          mainClass: FANCYBOX_MAIN_CLASS,
          dragToClose: true,
          Images: {
            zoom: true,
          },
          Carousel: {
            infinite: true,
          },
          Toolbar: {
            display: {
              left: ['infobar'],
              middle: [],
              right: ['close'],
            },
          },
        });

      }

      getZoomSlide(button) {
        const slide = {
          src: button.dataset.zoomSrc,
        };
        const width = Number(button.dataset.zoomWidth);
        const height = Number(button.dataset.zoomHeight);

        if (width > 0 && height > 0) {
          slide.width = width;
          slide.height = height;
        }

        return slide;
      }

      onMediaClick(event) {
        const zoomButton = event.target.closest(ZOOM_BUTTON_SELECTOR);

        if (zoomButton && this.contains(zoomButton)) {
          this.openZoom(zoomButton);
          return;
        }

        const control = event.target.closest('[data-media-index]');

        if (!control || !this.contains(control)) {
          return;
        }

        this.selectMedia(Number(control.dataset.mediaIndex));
      }

      selectMedia(index) {
        this.setActiveMedia(index);
        this.mainSlider.scrollToIndex(index);
      }

      setActiveMedia(index) {
        if (index < 0 || index >= this.mainItems.length || index === this.activeIndex) {
          return;
        }

        this.activeIndex = index;
        this.toggleActive(this.mainItems, index, false);
        this.toggleActive(this.thumbnailButtons, index, true, false);
        this.toggleActive(this.dots, index, true);
      }

      toggleActive(elements, index, useCurrent, useClass = true) {
        elements.forEach((element, elementIndex) => {
          const isActive = elementIndex === index;

          if (useClass) {
            element.classList.toggle(ACTIVE_CLASS, isActive);
          }

          if (!useCurrent) {
            return;
          }

          if (isActive) {
            element.setAttribute('aria-current', 'true');
            return;
          }

          element.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('product-media', ProductMedia);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-shipping-usp"] && !Shopify.designMode) return;
  try {
    const PRODUCT_SHIPPING_MESSAGE_SELECTOR = '[data-product-shipping-message]';
  const AMOUNT_PLACEHOLDER = '{' + '{ amount }}';
  const CENTS_PER_UNIT = 100;

  const updateProductShippingMessages = (cart) => {
    if (!cart || cart.total_price == null) {
      return;
    }

    const freeShippingLimit = Number(window.theme.settings.free_shipping_limit);

    if (!freeShippingLimit) {
      return;
    }

    const currencyRate = window.Shopify && window.Shopify.currency ? Number(window.Shopify.currency.rate) : 1;
    const freeShippingLimitCents = freeShippingLimit * CENTS_PER_UNIT * currencyRate;
    const cartQualifies = cart.total_price >= freeShippingLimitCents && cart.total_price !== 0;
    const amountLeft = Math.max(freeShippingLimitCents - cart.total_price, 0);
    const remainingMessage = window.theme.strings.freeShippingRemaining.replace(AMOUNT_PLACEHOLDER, window.theme.formatMoney(amountLeft));

    document.querySelectorAll(PRODUCT_SHIPPING_MESSAGE_SELECTOR).forEach((productMessage) => {
      const productPrice = Number(productMessage.dataset.productPrice) || 0;
      const productQualifies = productPrice >= freeShippingLimitCents && productPrice !== 0;
      const isQualified = cartQualifies || productQualifies;

      productMessage.textContent = isQualified
        ? window.theme.strings.qualifiedShippingMessage
        : remainingMessage;
    });
  };

  document.addEventListener('theme:cart:change', (event) => {
    updateProductShippingMessages(event.detail.cart);
  });
  } catch(e) { console.error(e); }
})();

})();
